module.exports = __webpack_public_path__ + "img/logo16.d0acb96a.jpg";